import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { PhotoUploaderModule } from '@classifieds-sell/trademe-core-ui';
import {
    TgGridModule,
    TgIconStarFillModule,
    TgIconStarModule,
    TgRackModule
} from '@trademe/tangram';
import { SummaryPagePhotosMediaSectionComponent } from './summary-page-photos-media-section.component';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        TgGridModule,
        TgRackModule,
        TgIconStarModule,
        TgIconStarFillModule,
        PhotoUploaderModule
    ],
    declarations: [SummaryPagePhotosMediaSectionComponent],
    exports: [SummaryPagePhotosMediaSectionComponent]
})
export class SummaryPagePhotosMediaSectionModule {}
